<template>
  <div class="money-pay">
    <!-- <div v-if="showDiscounts && inputPrice > 0">
      <el-card class="box-card activityList">
        <el-checkbox-group v-model="optionMutex" @change="changeOption">
          <div class="activity-cont">
            <span>
              <el-checkbox label="3">会员优惠</el-checkbox>
            </span>
            <span style="color:#f56c6c" v-if="vipdiscounts_status == 1"
              >{{ vipdiscounts }}折</span
            >
            <span style="color:#f56c6c" v-else-if="vipdiscounts_status == 2"
              >每升-{{ vipdiscounts }}元</span
            >
          </div>
          <div class="activity-cont">
            <span>
              <el-checkbox label="2">优惠券</el-checkbox>
              <span class="hint">({{ conponOwnNum }}张可用)</span>
            </span>
            <span @click="openConponList" style="cursor: pointer;">
              <span class="hint">(已使用{{ useNum }}张)</span>
              <span style="color:rgb(245, 108, 108)">{{ bottom_ticket }}</span>
            </span>
          </div>
          <div class="activity-cont">
            <span>
              <el-checkbox label="1">积分</el-checkbox>
              <span class="hint">({{ integralNum }}积分可用)</span>
            </span>
            <span>
              <span class="hint">(-{{ dedIntegral }}积分)</span>
              <span style="color:rgb(245, 108, 108)"
                >-{{ dedIntegralMoney }}元</span
              >
            </span>
          </div>
        </el-checkbox-group>
      </el-card>
    </div> -->
    <div class="No_preferentials" v-if="$route.query.key == 1">
      <div v-if="carList.length > 0">
        <div
          class="shop_goods_1"
          v-for="(item, i) in carList"
          :key="i"
          @click="select(item)"
        >
          <img
            style="
              width: 16%;
              height: 100%;
              border-radius: 10px;
              margin-right: 10px;
            "
            :src="item.pic"
          />
          <div class="shop_goods_2">
            <div class="shop_goods_2_1">
              <div style="font-size: 16px;">{{ item.title }}</div>
              <div>
                <el-button
                  style="height: 25px; display: flex; align-items: center;"
                  size="small"
                  type="danger"
                  icon="el-icon-delete"
                  @click="del(item)"
                ></el-button>
              </div>
            </div>
            <div class="shop_goods_2_1" style="line-height: 50px;">
              <div style="color: red;">¥{{ item.money }}</div>
              <div>×{{ item.num }}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="No_preferential" v-else>
        <img src="../../../../../../public/img/pay/zanwuyouhui.png" alt />
        <p>暂无数据</p>
      </div>
    </div>
    <div class="No_preferential" v-else>
      <img src="../../../../../../public/img/pay/zanwuyouhui.png" alt />
      <p>暂无优惠</p>
    </div>
    <div style="margin-bottom: 4px;" v-if="this.$route.query.key == 1">
      <el-card class="box-card pay_infor">
        <div class="pay_price" @click="fcous">
          <span>合计支付:</span>
          <div class="price">
            ￥
            <span>{{ allMoney }}</span>
          </div>
        </div>
      </el-card>
      <el-card class="box-card pay_infor">
        <div class="selectPay_type">
          <div
            v-for="(item, index) in pay_type"
            :key="index"
            class="pay_type"
            @click="chosePayType(index, item)"
            :class="payIndex == index ? 'pay_type_Active' : ''"
          >
            <img :src="item.imgUrl" alt v-if="item.imgStatus" />
            <span v-else>账户：{{ item.balance }}</span>
            <span>{{ item.name }}</span>
          </div>
        </div>
      </el-card>
      <el-card class="box-card pay_infor submitAccounts" style="margin: 0;">
        <el-button type="success" plain @click="passwordldPop">
          <img src="../../../../../../public/img/pay/jiezhang.png" alt />
          <span>结账</span>
        </el-button>
        <paySuccessEd ref="pay_Successed" @payEnd="payEnd"></paySuccessEd>
      </el-card>
    </div>
    <div style="margin-bottom: 4px;" v-else>
      <!-- <el-card class="box-card pay_infor">
        <div class="pay_price">
          <span>还需支付:</span>
          <div class="price">
            ￥
            <span v-if="inputPrice">{{ payPrice }}</span>
            <span v-else>0</span>
          </div>
        </div>
      </el-card> -->
      <!-- <el-card class="box-card pay_infor">
        <div class="selectPay_type">
          <div
            v-for="(item, index) in pay_type"
            :key="index"
            class="pay_type"
            @click="chosePayType(index)"
            :class="payIndex == index ? 'pay_type_Active' : ''"
          >
            <img :src="item.imgUrl" alt v-if="item.imgStatus" />
            <span v-else>账户：{{ item.balance }}</span>
            <span>{{ item.name }}</span>
          </div>
        </div>
      </el-card> -->
      <el-card class="box-card pay_infor" v-show="showRemark">
        <el-input placeholder="备注" v-model="remarkInput" clearable></el-input>
      </el-card>
      <el-card class="box-card pay_infor submitAccounts" style="margin: 0;">
        <el-button type="success" plain @click="passwordldPop">
          <img src="../../../../../../public/img/pay/jiezhang.png" alt />
          <span>结账</span>
        </el-button>
        <paySuccess
          ref="pay_Success"
          @payEnd="payEnd"
          :typeStatus="typeStatus"
          :type="1"
        ></paySuccess>
      </el-card>
    </div>

    <el-drawer
      custom-class="select_coupon-drawer"
      title="选取优惠券"
      :modal="false"
      :visible.sync="drawer"
      :withHeader="false"
    >
      <div class="select_coupon">
        <el-tabs v-model="activeName" @tab-click="getAvailable_coupon(true)">
          <el-tab-pane label="满减券" name="1"></el-tab-pane>
          <!-- <el-tab-pane label="折扣券" name="2"></el-tab-pane> -->
          <el-tab-pane label="代金券" name="3"></el-tab-pane>
        </el-tabs>
        <div class="coupon_list">
          <el-radio-group v-model="couponradio" size="small">
            <div
              class="coupon-item"
              v-for="(item, index) in conponList"
              :key="index"
            >
              <div class="style-three">
                <div class="info-box">
                  <div class="coupon-money">
                    <div class="lay of" v-if="item.coupon_data.type == 2">
                      <em>{{ item.coupon_data.zhe_discount }}</em>
                      折
                    </div>
                    <div class="lay of" v-else>
                      ￥
                      <em v-if="item.coupon_data.type == 1">
                        {{ item.coupon_data.m_dec_money }}
                      </em>
                      <em v-else>{{ item.coupon_data.d_face_value }}</em>
                    </div>
                    <div class="lay">
                      <p class="tit">{{ item.coupon_data.title }}</p>
                      <p class="demand">
                        该券最多可用{{ item.coupon_data.use_limit }}张，剩余{{
                          item.use_num
                        }}张
                      </p>
                      <div @click="nowconponIdx = index">
                        <el-input-number
                          v-if="item.coupon_data.type != 2"
                          v-model="item.stepperVal"
                          size="mini"
                          :min="1"
                          :max="
                            item.use_num < item.coupon_data.use_limit
                              ? item.use_num
                              : item.coupon_data.use_limit
                          "
                          label="描述文字"
                          :disabled="couponradio == item.id ? false : true"
                          @change="changeYhjNum"
                        ></el-input-number>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="get-btn">
                  <el-radio
                    :label="item.id"
                    @change="select_Cou(item)"
                    border
                    style="margin-left: 15px;"
                  >
                    选择
                  </el-radio>
                </div>
              </div>
            </div>
          </el-radio-group>
        </div>
      </div>
      <div class="noUseconpon">
        <el-button
          type="primary"
          plain
          @click=";(drawer = false), (couponradio = ''), noUseconpon()"
        >
          不使用优惠
        </el-button>
      </div>
    </el-drawer>
    <!-- ，密码确认弹窗 -->
    <el-dialog :visible.sync="passwordPopStatus" title="密码确认" width="400px">
      <el-form ref="form" :model="passwordForm" label-width="100px">
        <div v-if="!forgetStatus">
          <el-form-item label="请输入密码">
            <el-input
              v-model="passwordForm.confirmPassword"
              @input="changeIc"
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button type="text" @click="forgetStatus = true">
              忘记密码？
            </el-button>
          </el-form-item>
        </div>
        <div v-else>
          <el-form-item label="用户手机号">
            <el-input v-model="passwordForm.mobile" disabled></el-input>
          </el-form-item>
          <el-form-item label="校验码">
            <el-input placeholder="请输入内容" v-model="imgCode">
              <template slot="append">
                <img :src="imageBase64" alt="" style="width: 100px;height: 20px;" @click="getImageData"/>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="验证码">
            <el-input class="input_box" v-model="passwordForm.code">
              <template slot="append">
                <el-link
                  :disabled="btn_status"
                  @click="getCode(1)"
                  type="primary"
                >
                  {{ code_text }}
                </el-link>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="设置密码">
            <el-input
              show-password
              v-model="passwordForm.pay_pass"
              placeholder="请输入六位数字密码"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码">
            <el-input
              show-password
              v-model="passwordForm.re_pay_pass"
            ></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-button type="text" @click="forgetStatus = false">
              我记得密码
            </el-button>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer" v-if="forgetStatus">
        <el-button type="primary" @click="resetPassworld">重置密码</el-button>
      </span>
    </el-dialog>
    <!-- ，短信验证弹窗 -->
    <el-dialog
      :visible.sync="verificationStatus"
      title="短信验证"
      width="400px"
      :before-close="handleNote"
    >
      <el-form ref="form" label-width="100px">
        <div>
          <el-form-item label="校验码">
            <el-input placeholder="请输入内容" v-model="imgCode">
              <template slot="append">
                <img :src="imageBase64" alt="" style="width: 100px;height: 20px;" @click="getImageData"/>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label="验证码">
            <el-input class="input_box" v-model="verification_code">
              <template slot="append">
                <el-link
                  :disabled="btn_status"
                  @click="getCode(0)"
                  type="primary"
                >
                  {{ code_text }}
                </el-link>
              </template>
            </el-input>
          </el-form-item>
        </div>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="settleAccounts">
          确认
        </el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="等待用户出示付款码"
      :visible.sync="dialogVisibleScancode"
      width="400px"
      style="height: 600px; padding: 0; overflow: hidden;"
      :before-close="handleClosePos"
      destroy-on-close
    >
      <div v-loading="loading" :element-loading-text="loading_text">
        <img
          src="@public/img/saoma.gif"
          alt=""
          style="width: 360px; height: 340px;"
        />
        <el-input
          v-if="$route.query.key == 1"
          style="opacity: 0; width: 10px; height: 2px;"
          ref="inputbox_pay"
          @change="keyup_submit"
          size="mini"
          v-model="pay_code"
          @blur="Blur"
        ></el-input>
      </div>
    </el-dialog>
    <!--    微信支付宝-->
    <el-dialog
      :title="
        this.pay_type.length > 0
          ? this.pay_type[this.payIndex].name + '扫码支付'
          : ''
      "
      :visible.sync="dialogVisibleoline"
      width="360px"
      :before-close="handleClose"
      destroy-on-close
    >
      <vue-qr
        style="
          border: #000000 8px solid;
          border-radius: 20px;
          width: 100%;
          height: 100%;
        "
        :logoSrc="logo"
        :text="text"
        :size="300"
      ></vue-qr>
    </el-dialog>
    <!-- pos银行刷卡 -->
    <el-dialog
      title="等待用户刷卡"
      :visible.sync="dialogVisiblePos"
      width="400px"
      :before-close="handleClosePos"
      destroy-on-close
    >
      <!-- <div>请用户出示银行卡进行刷卡支付！！！</div> -->
      <img src="@public/img/wait.gif" alt="" style="width: 100%;" />
    </el-dialog>
  </div>
</template>

<script>
import {
  get_point,
  getAvailable_coupon,
  getVipDiscount,
  integralOrders,
  vipAccountEdit,
} from '@/api/vip'
import { getConfigButton } from '@/api/set'
import { iCSendSms, scan_pay, setPayPass, verifyPayPass } from '@/api/ic'
import { order_status } from '@/api/pay'
import paySuccess from './paySuccessIntegral'
import paySuccessEd from './paySuccess'
import { getCouponSetting } from '@/api/couponSetting'
import verificationCode from '@/utils/verificationCode'
import { detail, submit_shoporder_money } from '@/api/order'
import { orderDelete } from '@/api/integralMall'
import { mapActions, mapGetters } from 'vuex'
import vueQr from 'vue-qr'

export default {
  computed: {
    ...mapGetters(['token', 'app_id', 'carList', 'allMoney', 'show_data']),
  },
  components: {
    paySuccess,
    paySuccessEd,
    vueQr,
  },
  props: ['inputPrice', 'integralNum', 'user_infor', 'oil_infor', 'showRemark'],
  data() {
    return {
      text: '',
      loading_text: '用户付款中...',
      logo: '',
      loading: false,
      dialogVisiblePos: false, //扫码支付弹框
      shop_goods: [],
      payPrice: 0, // 最终支付金额
      openMutex: false, // 积分互斥规则
      vipdiscounts: '', // 会员优惠
      conponList: [], // 优惠券列表
      conponType: '',
      useNum: 0, // 当前选中优惠券的数量
      bottom_ticket: `选择优惠券`, //优惠券提示
      couponIds: '', //优惠券id串
      upPrice: 0, // 上一次优惠券抵扣金额
      nowconponIdx: '', // 优惠券idx
      dedIntegral: 0, // 使用的抵扣积分
      dedIntegralMoney: 0, // 抵扣积分减免的钱
      conponOwnNum: 0,
      vipdiscounts_status: 0,
      activeName: '1',
      openIntegral: false, // 是否启用积分
      openMember: false, // 是否启用会员折扣
      num: '',
      couponradio: '',
      showDiscounts: false,
      remarkInput: '', // 备注
      drawer: false,
      payIndex: '0', // 支付方式选项
      pay_type: [
        {
          name: '扫码支付',
          payment_code: 'scan',
          imgUrl: require('../../../../../../public/img/fukuan.png'),
          imgStatus: true, //true  显示图片 false显示文本
        },
        {
          name: '现金',
          payment_code: 'cash',
          imgUrl: require('../../../../../../public/img/pay/xianjin.png'),
          imgStatus: true, //true  显示图片 false显示文本
        },
        {
          name: '微信',
          payment_code: 'wxpay',
          imgUrl: require('../../../../../../public/img/pay/weixin.png'),
          imgStatus: true, //true  显示图片 false显示文本
        },
        {
          name: '支付宝',
          payment_code: 'unionpay',
          imgUrl: require('../../../../../../public/img/pay/zhifu.png'),
          imgStatus: true, //true  显示图片 false显示文本
        },
        // {
        //   name: "刷卡",
        //   payment_code: "pos",
        //   imgUrl: require("../../../../../../public/img/pay/yinhangka.png"),
        //   imgStatus: true //true  显示图片 false显示文本
        // }
      ],
      pay_code: '',
      payment_code: 'scan',
      passwordPopStatus: false,
      forgetStatus: false,
      passwordForm: {
        confirmPassword: '',
        mobile: '',
        code: '',
        pay_pass: '',
        re_pay_pass: '',
      },
      code_num: '',
      code_text: '获取验证码',
      btn_status: false,
      timer: null,
      now_code: '',
      setStatus: false, //凑整设置
      mutexData: [], //后台设置项
      optionMutex: [], //互斥选项(前端选的)
      optionShell: ['1', '2', '3'], //页面所有选项值(1 积分 2 优惠券  3 会员折扣)
      choseVipDiscount: '', //用于计算优惠的会员折扣（）
      typeStatus: false,
      verificationStatus: false,
      verification_code: '',
      dialogVisibleoline: false,
      dialogVisibleScancode: false,
      order_id: '',
      imageBase64:"",
      uuid:"",
      imgCode:""
    }
  },
  mounted() {
    this.details()
    this.configuration()
  },
  methods: {
    ...mapActions(['jianNum', 'setData', 'delShop_car', 'setFocus']),
    async getImageData(){
      const data = await verificationCode.getImage();
      if(data){
        console.log("验证图片", data);
      this.imageBase64 = data.img;
      this.uuid = data.uuid;
      this.imgCode = ""
    }
  },
    //订单取消
    async del_order(id) {
      let data = {
        app_id: this.app_id,
        id: id,
      }
      const res = await orderDelete(data)
    },
    Blur() {
      this.$refs.inputbox_pay.focus()
    },
    fcous() {
      this.setFocus(true)
    },
    //弹窗关闭
    handleClose(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
          this.text = ''
          clearInterval(this.timer)
          this.del_order(this.order_id)
        })
        .catch((_) => {})
    },
    handleClosePos(done) {
      this.$confirm('确认关闭？')
        .then((_) => {
          done()
          // this.del_order(this.order_id)
          clearInterval(this.timer)
        })
        .catch((_) => {})
    },
    //扫码支付
    async keyup_submit() {
      this.loading = true
      let shop_car = JSON.parse(localStorage.getItem('shop_goods'))
      shop_car.forEach((item, i) => { 
        item.good_id = item.id
        delete item.money
        delete item.pic
        delete item.stock
        delete item.title
        delete item.id
      })
      let data = {
        app_id: this.app_id,
        goods_list: JSON.stringify(shop_car),
        order_source: 'pc',
        payment_code: this.payment_code,
        uid: this.user_infor ? this.user_infor[0].uid : 0,
        recharge: 0,
        operator_id: localStorage.getItem('choseStaffId')
          ? localStorage.getItem('choseStaffId')
          : '', //员工ID
        auth_code: this.pay_code,
      }
      const res = await scan_pay(data)
      if (res.code == 200) {
        this.$message.success('支付成功')
        this.delShop_car()
        this.loading = false
        this.dialogVisibleScancode = false
        setTimeout(() => {
          location.reload()
        }, 800)
      } else if (res.code == 202) {
        let order_sn = []
        if (res.data.order_sn.includes(',')) {
          order_sn = res.data.order_sn.split(',')
        } else {
          order_sn = [res.data.order_sn]
        }
        let order_detail_data = {
          app_id: this.app_id,
          order_sn: order_sn[0],
        }
        this.timer = setInterval(() => {
          order_status(order_detail_data).then((ress) => {
            if (ress.code == 200) {
              this.$message.success('支付成功')
              this.loading_text = '支付成功'
              clearInterval(this.timer)
              this.delShop_car()
              this.timer = null
              this.pay_code = ''
              setTimeout(() => {
                this.loading = false
                this.dialogVisibleScancode = false
                location.reload()
              }, 2000)
            } else if (ress.code == 202) {
              this.pay_code = ''
              this.$refs.inputbox_pay.focus()
            } else {
              this.$message.error(ress.msg)
              this.loading_text = '用户付款中...'
              clearInterval(this.timer)
              this.timer = null
              this.loading = false
              this.del_order(order_sn.join(','))
              this.pay_code = ''
              this.$refs.inputbox_pay.focus()
            }
          })
        }, 3000)
      } else {
        this.$message.error(res.msg)
        this.loading = false
        this.pay_code = ''
        this.$refs.inputbox_pay.focus()
      }
      console.log('pay', res)
    },
    ///已选商品
    select(item) {
      console.log(item)
      this.setData(item)
      this.fcous()
    },
    //删除
    del(item) {
      this.jianNum(item.id)
      this.fcous()
    },
    // 关闭
    handleNote() {
      this.$confirm('确认关闭,不继续下单？')
        .then((_) => {
          // done();
          this.btn_status = false
          this.timer = null
          this.code_text = '获取验证码'
          this.verificationStatus = false
          this.verification_code = ''
        })
        .catch((_) => {})
    },
    changeOption(val) {
      let oldData = val
      this.optionMutex = []
      let metexShell = [] //互斥的选项
      oldData.forEach((item) => {
        if (!this.mutexData.includes(item)) {
          this.optionMutex.push(item)
        } else {
          metexShell.push(item)
        }
      })
      if (metexShell.length) {
        this.$message.warning('优惠互斥，优惠不同享！！')
        this.optionMutex.push(metexShell[metexShell.length - 1])
      }
      // 重新計算价格
      // 1.积分清空
      this.dedIntegral = 0
      this.dedIntegralMoney = 0
      // 2.优惠券清空
      this.couponradio = ''
      this.noUseconpon()
      // 3.会员折扣清空
      this.choseVipDiscount = ''
      this.optionMutex.forEach((item) => {
        if (item == '1') {
          this.get_point()
        } else if (item == '2') {
          this.getAvailable_coupon()
          this.setDefault()
        } else if (item == '3') {
          this.choseVipDiscount = this.vipdiscounts
        }
      })
      this.calculatePrice()
      // } else {
      //   this.dedIntegral = 0;
      //   this.dedIntegralMoney = 0;
      //   this.calculatePrice();
      // }
    },
    chosePayType(index, it) {
      this.payIndex = index
      if (this.$route.query.key == 1) {
        this.fcous()
        this.payment_code = it.payment_code
      } else {
        this.calculatePrice()
      }
      // let status = await this.configuration();
      // if (index == 0 && this.setStatus) {
      //   this.payPrice = Number(this.payPrice).toFixed(0);
      // }
    },
    configuration() {
      var data = {
        token: this.token,
        app_id: this.app_id,
      }
      getConfigButton(data).then((res) => {
        if (res.code == 200) {
          console.log(res.data)
          res.data.value.forEach((item) => {
            if (item.name == 'cash_int') {
              this.setStatus = item.status == 1
              console.log('凑整配置 状态', this.setStatus)
            }
          })
        }
      })
      // getCouponSetting(data).then(res => {
      //   console.log("请求数据", res);
      //   // if (res.data.offline_buy != "") {
      //   //   this.offline_buy = res.data.offline_buy.split(",");
      //   // }
      // });
    },
    //重置密码
    resetPassworld() {
      let data = {
        app_id: this.app_id,
        token: this.token,
        mobile: this.passwordForm.mobile,
        code: this.passwordForm.code,
        pay_pass: this.passwordForm.pay_pass,
        re_pay_pass: this.passwordForm.re_pay_pass,
      }
      setPayPass(data).then((res) => {
        console.log('122', res)
        if (res.code == 200) {
          this.$message.success('绑定成功！！')
          this.forgetStatus = false
        } else {
          this.$message.warning(res.msg)
        }
      })
    },
    // 密码弹窗
    async passwordldPop() {
      console.log('2222')
      if (this.$route.query.key == 1) {
        let shop_car = JSON.parse(localStorage.getItem('shop_goods'))
        if (shop_car.length > 0) {
          console.log()
          if (this.payment_code == 'scan') {
            this.dialogVisibleScancode = true
            this.$nextTick(() => {
              this.$refs.inputbox_pay.focus()
            })
          } else {
            shop_car.forEach((item, i) => {
              item.good_id = item.id
              delete item.money
              delete item.pic
              delete item.stock
              delete item.title
              delete item.id
            })
            let data = {
              app_id: this.app_id,
              goods_list: JSON.stringify(shop_car),
              order_source: 'pc',
              payment_code: this.payment_code,
              uid: this.user_infor ? this.user_infor[0].uid : 0,
              recharge: 0,
              operator_id: localStorage.getItem('choseStaffId')
                ? localStorage.getItem('choseStaffId')
                : '', //员工ID
            }
            let order_detail_data = {
              app_id: this.app_id,
              id: '',
            }
            const res = await submit_shoporder_money(data)
            if (res.code != 200) {
              this.$message.error(res.msg)
              return
            }
            this.order_id = res.data.order_id
            if (res.data.order_id.includes(',')) {
              order_detail_data.id = res.data.order_id.split(',')[0]
            } else {
              order_detail_data.id = res.data.order_id
            }

            switch (this.payment_code) {
              case 'scan':
                break
              case 'cash':
                if (res.code == 200) {
                  console.log('pppp', res)
                  const order_detail = await detail(order_detail_data)
                  if (order_detail.code == 200) {
                    this.$refs.pay_Successed.orderData = {
                      money: res.data.money,
                      create_time: order_detail.data.create_time,
                      payment_code: 'cash',
                      paysn: res.data.paysn,
                      id: res.data.order_id,
                    }
                    this.$refs.pay_Successed.paySuccess = true
                  }
                }
                break
              default:
                if (this.payment_code == 'pos') {
                  this.dialogVisiblePos = true
                } else {
                  this.text = res.data.qr_code
                  if (this.payment_code == 'wxpay') {
                    this.logo = require('../../../../../../public/img/pay/weixin.png')
                  } else {
                    this.logo = require('../../../../../../public/img/pay/zhifu.png')
                  }
                  this.dialogVisibleoline = true
                }

                this.timer = setInterval(() => {
                  detail(order_detail_data).then((ress) => {
                    if (ress.code == 200) {
                      if (ress.data.pay_status == 1) {
                        clearInterval(this.timer)
                        this.delShop_car()
                        this.$alert(
                          `${
                            this.pay_type[this.payIndex].name
                          }支付成功, 请用户查看${
                            this.pay_type[this.payIndex].name
                          }消息通知`,
                          '成功',
                          {
                            confirmButtonText: '确定',
                            callback: (action) => {
                              this.timer = null
                              if (this.payIndex == 4) {
                                this.dialogVisiblePos = false
                              } else {
                                this.dialogVisibleoline = false
                              }
                              location.reload()
                            },
                          },
                        )
                      }
                    }
                  })
                }, 4000)
                break
            }
          }
        } else {
          this.$message.error('请先选择商品!!')
        }
      } else {
        if (this.payIndex != 0) {

          this.passwordPopStatus = true
          this.passwordForm.mobile = this.user_infor[0].mobile
          // this.passwordPopStatus = true;
        } else {
          this.settleAccounts()
        }
      }
    },
    changeIc() {
      console.log('ka', this.passwordForm.confirmPassword.length)
      if (this.passwordForm.confirmPassword.length == 6) {
        console.log('ka')
        let data = {
          token: this.token,
          app_id: this.app_id,
          uid: this.user_infor[0].uid,
          pay_pass: this.passwordForm.confirmPassword,
        }
        verifyPayPass(data).then((res) => {
          if (res.code == 200) {
            this.$message.success('密码正确！！')
            this.settleAccounts()
            this.passwordPopStatus = false
          } else {
            this.$message.warning(res.msg)
          }
          console.log('数据', res)
        })
      }
    },
    getCode(type = 0) {
      console.log('type', type)
      const TIME_COUNT = 60
      if (!this.timer) {
        this.count = TIME_COUNT
        if (type == 0) {
          // 向管理员发送验证码
          verificationCode.SendMyCode({uuid:this.uuid,code:this.imgCode})
        } else {
          this.SendUserCode()
        }
        this.timer = setInterval(() => {
          if (this.count > 0 && this.count <= TIME_COUNT) {
            this.count--
            this.code_text = this.count + 's'
            this.btn_status = true
          } else {
            this.btn_status = false
            this.timer = null
            this.code_text = '获取验证码'
          }
        }, 1000)
      }
    },
    // 向用户发送验证码
    async SendUserCode() {
      try {
        var data = {
          app_id: this.app_id,
          token: this.token,
          mobile: this.passwordForm.mobile,
          uuid:this.uuid,
          code:this.imgCode
        }
        const res = await iCSendSms(data)
        if (res.code == 200) {
          this.$message.success(res.msg)
        } else {
          this.$message.error(res.msg)
        }
      } catch (error) {
        console.log(error)
      }
    },
    // 获取vip优惠
    getVipDiscount(id, cate, goods_id, money) {
      let vipData = {
        token: this.token,
        app_id: this.app_id,
        id,
        cate,
        goods_id,
        money,
      }
      getVipDiscount(vipData).then((res) => {
        if (res.code == 200) {
          console.log('会员折扣', res)
          this.vipdiscounts_status = res.data.status
          if (res.data.status == 1) {
            this.vipdiscounts = res.data.zhe / 10
          } else if (res.data.status == 2) {
            this.vipdiscounts = res.data.money
          } else {
            this.vipdiscounts = '暂无优惠信息'
          }
          this.optionMutex = this.pitchSet()
          this.changeOption(this.optionMutex)
        }
      })
    },
    // 结账
    async settleAccounts() {
      // 安全設置详情 积分;
      // await verificationCode.get_detail("open_sms_point").then(pointStatus => {
      //   console.log("安全設置详情", pointStatus);
      //   if (pointStatus && this.verification_code == "") {
      //     this.verificationStatus = true;
      //   } else {
      //     }
      // });
      let cashOrderStatus = await verificationCode.get_detail('open_sms_point')
      try {
        this.$confirm('确定要进行操作吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
        })
          .then(() => {
            this.typeStatus = this.$parent.typeMethods
            console.log('this.$parent.typeMethods', this.$parent.typeMethods) // 减积分 typeMethods 减积分
            if (this.typeStatus !== 0) {
              console.log('22222')
              // vipAccountEdit()
              // 减积分
              console.log('info', this.$parent.mobile)
              let data = {
                app_id: this.app_id,
                token: this.token,
                type: 2,
                uid: this.user_infor[0].uid,
                operate_type: this.$parent.typeMethods,
                num: this.inputPrice,
                account_type: 1,
                remark: this.remarkInput,
                operator_id: localStorage.getItem('choseStaffId')
                  ? localStorage.getItem('choseStaffId')
                  : '', //员工ID
              }
              // 安全設置详情 储值现金;
              console.log('安全設置详情', cashOrderStatus)
              if (cashOrderStatus && this.verification_code == '') {
                this.getImageData()
                this.verificationStatus = true
                return
              } else {
                data.verification_code = this.verification_code
              }
              vipAccountEdit(data).then((res) => {
                if (res.code == 200) {
                  let info_point = 0
                  if (this.typeStatus == 1) {
                    info_point =
                      Number(this.user_infor[0].point) + Number(data.num)
                  } else {
                    info_point =
                      Number(this.user_infor[0].point) - Number(data.num)
                  }

                  let SuccessData = {
                    msg: res.msg,
                    title: `${this.typeStatus == 1 ? '加积分' : '减积分'}`,
                    point: data.num,
                    mobile: this.user_infor[0].mobile,
                    info_point: info_point,
                  }
                  this.$refs.pay_Success.orderData = SuccessData
                  this.$refs.pay_Success.paySuccess = true
                  this.$parent.getData()
                  this.$parent.status()
                  // this.$parent.show_user_infor = false
                  this.$parent.inputPrice = ''

                  // 短信
                  this.btn_status = false
                  this.timer = null
                  this.code_text = '获取验证码'
                  this.verificationStatus = false
                  this.verification_code = ''
                } else {
                  this.$message.warning(res.msg)
                }
              })
            } else {
              console.log('111', this.oil_infor.id)
              let data = {
                app_id: this.app_id,
                token: this.token,
                good_id: this.oil_infor.id,
                num: 1,
                order_source: 2,
                // message: this.remarkInput,
                uid: this.user_infor[0].uid,
                // room_id: this.$parent.room_id,
                operator_id: localStorage.getItem('choseStaffId')
                  ? localStorage.getItem('choseStaffId')
                  : '', //员工ID
              }
              integralOrders(data).then((res) => {
                console.log(res)
                if (res.code == 200) {
                  this.$message.success(res.msg)
                  this.$parent.status()
                  // let orderData = {
                  //   app_id: this.app_id,
                  //   token: this.token,
                  //   id: res.order_id
                  // };
                  // integralOrderDetail(orderData).then(res => {
                  //   this.$refs.pay_Success.orderData = res.data;
                  //   this.$refs.pay_Success.paySuccess = true;
                  //   this.$parent.getData();
                  //   this.inputPrice = "";
                  // });
                } else {
                  this.$message.warning(res.msg)
                }
              })
            }
          })
          .catch(() => {
            this.$message({
              type: 'info',
              message: '已取消开启',
            })
          })
      } catch (e) {
        console.log('cuo', e)
      }
    },

    // 显示优惠券列表
    openConponList() {
      //选择优惠券
      if (!this.optionMutex.includes('2')) {
        return this.$message.warning('您还没有勾选是否进行优惠券使用！！')
      }
      this.drawer = true
      if (this.conponList.length == 0) {
        this.getAvailable_coupon(true)
      }
    },
    // 获取优惠券列表
    getAvailable_coupon(present = false) {
      this.noUseconpon(present)
      let data = {
        token: this.token,
        app_id: this.app_id,
        money: this.inputPrice,
        uid: this.user_infor[0].uid,
        status: this.activeName,
        goods_id: this.$parent.oil_infor.goods.id,
      }
      getAvailable_coupon(data).then((res) => {
        if (res.code == 200) {
          console.log('获取全部类型优惠2')

          if (res.data.length > 0) {
            for (let i = 0; i < res.data.length; i++) {
              const element = res.data[i]
              if (element.id == this.couponradio) {
                element.stepperVal = this.useNum
              } else {
                element.stepperVal = 1
              }
              this.conponList.push(element)
            }
            this.conponOwnNum = res.num
            // if (!present) {
            //   this.setDefault();
            // }
            if (this.optionMutex.includes('2')) {
              this.setDefault()
            }
          }
        }
        // } else {
        //   this.upPrice = 0;
        //   this.calculatePrice();
        // }
      })
    },
    //设置默认优惠券
    judgeUse(predict, use_num, use_limit) {
      let ultimatelyNum = ''
      if (predict > use_num && use_num > use_limit) {
        // 预计大于拥有且拥有大于最大使用
        ultimatelyNum = use_limit
      } else if (predict > use_num && use_num < use_limit) {
        // 预计大于拥有且拥有小于最大使用
        ultimatelyNum = use_num
      } else if (predict > use_num && use_num == use_limit) {
        // 预计大于拥有且拥有==最大使用
        ultimatelyNum = use_num
      } else if (predict < use_num && predict > use_limit) {
        // 预计小于拥有且预计大于最大使用
        ultimatelyNum = use_limit
      } else if (predict < use_num && predict < use_limit) {
        // 预计<拥有且预计<最大使用
        ultimatelyNum = predict
      } else if (predict < use_num && predict == use_limit) {
        // 预计<拥有且预计==最大使用
        ultimatelyNum = predict
      } else if (predict == use_num && predict > use_limit) {
        // 预计= 拥有且预计<最大使用
        ultimatelyNum = use_limit
      } else if (predict == use_num && predict < use_limit) {
        // 预计=拥有且预计<最大使用
        ultimatelyNum = predict
      } else {
        // 预计=拥有且预计=最大使用
        ultimatelyNum = predict
      }
      // if (type == 1) {
      //   this.useNum = ultimatelyNum
      // } else {
      return ultimatelyNum
      // }
    },
    changeYhjNum(newVal, oldval) {
      setTimeout(() => {
        if (newVal > oldval) {
          this.useMulti(this.conponList[this.nowconponIdx], this.nowconponIdx)
        } else {
          this.useReduce(this.conponList[this.nowconponIdx])
        }
      }, 200)
    },
    useMulti(item, idx) {
      if (item.coupon_data.m_enough_money > 0) {
        // 右门槛
        if (
          item.coupon_data.m_enough_money * item.stepperVal >
            this.$parent.inputPrice ||
          item.coupon_data.d_face_value * item.stepperVal >
            this.$parent.inputPrice
        ) {
          this.$message(`您最多可以使用${this.useNum}张`)
          this.conponList[idx].stepperVal--
          this.useNum = item.stepperVal
          this.set_radio(item)
        } else {
          this.useNum = item.stepperVal
          this.set_radio(item)
        }
      } else {
        if (
          item.coupon_data.m_dec_money * item.stepperVal >
            this.$parent.inputPrice ||
          item.coupon_data.d_face_value * item.stepperVal >
            this.$parent.inputPrice
        ) {
          this.$message(`您最多可以使用${this.useNum}张`)
          this.conponList[idx].stepperVal--
          this.useNum = item.stepperVal
          this.set_radio(item)
        } else {
          this.useNum = item.stepperVal
          this.set_radio(item)
        }
      }
    },
    useReduce(item) {
      this.useNum = item.stepperVal
      this.set_radio(item)
    },
    select_Cou(item) {
      console.log('1212请求')
      for (let i = 0; i < this.conponList.length; i++) {
        const element = this.conponList[i]
        element.stepperVal = 1
      }
      this.useNum = item.stepperVal
      if (this.openMutex) {
        this.openIntegral = false
      }
      this.set_radio(item)
    },
    // 选择优惠券
    set_radio(item) {
      // 点击显示单选按钮
      this.couponradio = item.id
      console.log(item.coupon_type)
      switch (item.coupon_type) {
        // 满减券计算
        case 1:
          this.couponIds = item.coupon_data_ids.slice(0, this.useNum).join()
          this.upPrice = item.coupon_data.m_dec_money * this.useNum
          this.bottom_ticket = `-${
            item.coupon_data.m_dec_money * this.useNum
          }元`
          break
        // 折扣券计算
        case 2:
          if (item.coupon_data.zhe_limit == 1) {
            // 是否开启了优惠券最大折扣金额
            this.bottom_ticket = `${item.coupon_data.zhe_discount}折`
            console.log(this.$parent.inputPrice * item.coupon_data.zhe_discount)
            if (
              this.$parent.inputPrice *
                (1 - item.coupon_data.zhe_discount / 10) >
              Number(item.coupon_data.zhe_limit_money)
            ) {
              this.$message(
                `您使用的${item.coupon_data.zhe_discount}折优惠券,最大只能优惠${item.coupon_data.zhe_limit_money}元`,
              )
              this.upPrice = Number(item.coupon_data.zhe_limit_money)
            } else {
              this.upPrice =
                Number(this.$parent.inputPrice) -
                (Number(this.$parent.inputPrice) *
                  Number(item.coupon_data.zhe_discount)) /
                  10
            }
          } else {
            this.bottom_ticket = `${item.coupon_data.zhe_discount}折`
            this.upPrice =
              Number(this.$parent.inputPrice) -
              (Number(this.$parent.inputPrice) *
                Number(item.coupon_data.zhe_discount)) /
                10
          }
          this.couponIds = item.coupon_data_ids.slice(0, 1).join()
          break
        // 代金券
        case 3:
          this.couponIds = item.coupon_data_ids.slice(0, this.useNum).join()
          this.bottom_ticket = `-${
            item.coupon_data.d_face_value * this.useNum
          }元`
          this.upPrice = item.coupon_data.d_face_value * this.useNum
          break
        default:
          break
      }
      this.conponType = item.coupon_type
      this.calculatePrice()
    },
    // 清除状态
    noUseconpon(present) {
      this.conponList = []
      this.useNum = 0
      this.couponIds = ''
      this.bottom_ticket = '选择优惠券'
      this.upPrice = 0
      this.couponradio = ''
      if (!present) {
        this.activeName = '1'
      }
    },
    // 获取积分抵扣
    get_point() {
      let data = {
        token: this.token,
        app_id: this.app_id,
        goods_id: this.oil_infor.goods.id,
        amount: this.inputPrice,
        payment_code: 'cash',
        uid: this.user_infor[0].uid,
      }
      get_point(data).then((res) => {
        if (res.code == 200) {
          if (res.money == 0) {
            this.$message(res.msg)
            this.dedIntegral = 0
            this.dedIntegralMoney = 0
            // this.openIntegral = false;
          } else {
            this.dedIntegral = parseInt(res.maxUsePoint)
            this.dedIntegralMoney = res.money
            if (this.openMutex) {
              // 开启互斥，取消优惠券选中
              this.couponradio = ''
              this.noUseconpon()
            }
            this.calculatePrice()
          }
        }
      })
    },
    // 是否开启互斥
    details() {
      let data = {
        token: this.token,
        app_id: this.app_id,
      }
      getCouponSetting(data).then((res) => {
        console.log('请求数据互斥数据', res)
        this.mutexData = res.data.offline_buy.split(',')
        // 默认选中数据
        if (this.mutexData.length >= 2) {
          this.openMutex = true //开启互斥
        } else {
          this.openMutex = false //关闭互斥
        }
      })
    },
    // 优惠项的选择
    pitchSet() {
      let choseShell = []
      if (this.openMutex) {
        // 有互斥的情况
        if (this.mutexData.length == this.optionShell.length) {
          // 1.全部互斥的情况
          let num = this.priorityData()
          choseShell.push(num)
        } else {
          // 2.部分互斥时
          this.optionShell.forEach((item) => {
            if (
              !this.mutexData.includes(item) &&
              this.vipdiscounts_status != 0
            ) {
              choseShell.push(item)
            }
          })
          let num = this.priorityData()
          choseShell.push(num) //默认取相互互斥的选项中的第一个数据
        }
      } else {
        // 沒有互斥
        choseShell = this.optionShell
      }
      console.log('互斥數據', this.openMutex, choseShell)
      return choseShell
    },
    priorityData() {
      let num = ''
      if (this.vipdiscounts_status != 0) {
        // 會員有优惠
        return (num = this.mutexData[0])
      } else {
        // 没有优惠
        for (let i in this.mutexData) {
          if (this.mutexData[i] != '3') {
            num = this.mutexData[i]
            return num
          }
        }
      }
    },
    // 判断互斥规则
    judgeRule(arr) {
      if (arr.indexOf('1') != -1 && arr.indexOf('2') != -1) {
        this.openMutex = true //开启互斥
      } else {
        this.openMutex = false //关闭互斥
      }
    },
    // 结账后刷新用户信息
    payEnd() {
      this.$emit('payEnd')
    },
  },
}
</script>

<style lang="scss" scoped>
@import url('./discount.scss');
.money-pay {
  flex: 1;
  height: auto;
  padding: 0 10px;
  padding-right: 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  .box-card {
    margin-bottom: 10px;
    .el-card__body {
      padding: 10px 15px;
    }
    .pay-money {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .el-input {
        flex: 1;
        text-align: right;
        .el-input__inner {
          border: 0;
          text-align: right;
          color: #f56c6c;
          font-size: 30px;
        }
      }
    }
    .oilinfor {
      display: flex;
      justify-content: space-between;
      height: 30px;
      line-height: 30px;
      font-size: 18px;

      .oilinfor-name {
        color: #999;

        .oil {
          color: #e6a23c;
        }
      }
    }
    .weight {
      font-size: 18px;
      height: 30px;
      line-height: 30px;
      color: #999;
    }
  }
  .activityList {
    .activity-cont {
      font-size: 16px;
      display: flex;
      justify-content: space-between;
      margin-bottom: 20px;
      line-height: 20px;
      height: 20px;
      .hint {
        font-size: 14px;
        color: #999;
        margin-right: 5px;
      }
    }
    .activity-cont:last-child {
      margin-bottom: 0px;
    }
  }
  .No_preferential {
    width: 100%;
    height: 250px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: #fff;
    color: #bfbfbf;
    font-size: 18px;
    border-radius: 5px;
    img {
      width: 20%;
    }
  }
  .No_preferentials {
    width: 100%;
    height: 550px;
    overflow-y: auto;
    background: #fff;
    font-size: 18px;
    border-radius: 5px;
    .shop_goods_1 {
      width: 90%;
      cursor: pointer;
      height: 90px;
      margin: 10px auto;
      display: flex;
      padding: 10px;
      border-radius: 5px;
      background-color: #f8f8f8;
      .shop_goods_2 {
        width: 80%;
        height: 100%;
        .shop_goods_2_1 {
          height: 50%;
          display: flex;
          justify-content: space-between;
        }
      }
    }
  }
  .pay_infor {
    margin-bottom: 10px;
    .pay_price {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .price {
        color: #f56c6c;
        span {
          font-size: 24px;
        }
      }
    }
    .pay_type {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: space-between;
      flex: 1;
      margin: 0 10px;
      background: #f3f3f3;
      border-radius: 5px;
      padding: 10px 0;
      border: 1px solid #d8d8d8;
      img {
        width: 40px;
      }
    }
    .pay_type_Active {
      border: 1px solid #409eff;
      background: #fff;
    }
  }
  .submitAccounts {
    .el-button {
      width: 100%;
      height: 70px;
      background: linear-gradient(90deg, #fd7f51, #fc3b39);
      color: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;
      img {
        width: 24px;
        margin-right: 10px;
      }
    }
  }
  .selectPay_type {
    display: flex;
    cursor: pointer;
    span {
      text-align: center;
    }
  }
}

.coupon_list {
  padding: 0 30px;
  height: 100%;
  overflow: auto;

  .el-radio-group {
    width: 100%;
  }
}
.noUseconpon {
  width: 100%;
  position: absolute;
  // height: 40px;
  bottom: 0;
  padding: 0 10px 10px;
  z-index: 9;

  .el-button {
    width: 100%;
  }
}
.qrcode {
  display: inline-block;
  position: relative;
  margin-top: 0.2rem;
}
.logoimg {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 60px;
  height: 60px;
  margin-top: -30px;
  margin-left: -30px;
}
</style>

<style lang="scss">
.coupon-money {
  .el-input-number--mini {
    line-height: 20px;
  }
  .el-input--mini .el-input__inner {
    height: 20px;
    line-height: 20px;
    border: 1px solid #378ae8;
    background-color: #ffffff3b;
    color: #fff;
  }
  .el-input-number__decrease,
  .el-input-number__increase {
    background: transparent;
    border: 0;
    color: #fff;
  }
}
.select_coupon {
  .el-tabs__nav-scroll {
    display: flex;
    justify-content: center;
  }
  .el-tabs__item {
    padding: 0 40px !important;
    font-size: 16px;
  }
}
.select_coupon-drawer {
  .el-drawer__header {
    margin-bottom: 16px;
  }
}
</style>
